import { Link, useLocation } from "react-router-dom";

const AppBar = () => {
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    return (
        <nav className="navbar">
            <Link to="/" className="navbar-left">
                <img src="/images/zubaide.png" alt="Logo" className="navbar-logo" />
                <span className="navbar-title">ZUBAI DESIGN</span>
            </Link>

            <div className="navbar-links">
                <Link to="/" className={isActive("/") ? "active" : ""}>WORK</Link>
                <Link to="/about" className={isActive("/about") ? "active" : ""}>ABOUT</Link>
            </div>
        </nav>
    );
};

export default AppBar;
